export default "__VITE_ASSET__becae00b__"